export default {
  primary: "#cfe5fb",
  warning: "#CC4400",
  blue: "#0080FF",
  green: "#4FC445",
  gray: "#6C7680",
};
